module.exports = __webpack_public_path__ + "ba54309b476e92d3cddce6923b3fa062.pdf";